import React from "react";
import { Link } from "react-router-dom";

/**
 * Раздел, которого ещё нет.
 *
 * До этого Конструктор, Проекты и AI Ассистент вели на «Главную»: человек
 * нажимал пункт меню и оказывался там же, откуда ушёл, а в сайдбаре
 * подсвечивались сразу четыре раздела — тема считает активным любой пункт,
 * чей адрес совпал с текущим.
 *
 * Пустая страница честнее такого возврата: видно, что раздел существует,
 * почему он закрыт и что делать дальше.
 */

const PUBLIC = process.env.PUBLIC_URL || "";

const SoonPage = ({ title, lead, note, needsRole }) => (
  <div className="fw-page">
    <h1 className="fw-title">{title}</h1>
    <p className="fw-sub">{lead}</p>

    <section className="fw-card fw-empty">
      <span className="ic">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      </span>
      <b>{needsRole ? "Открывается вместе с ролью" : "Раздел готовится"}</b>
      <p>{note}</p>
      {needsRole && (
        <Link className="fw-btn" to={`${PUBLIC}/profile`}>
          Выбрать роль
        </Link>
      )}
    </section>
  </div>
);

export const ProjectsPage = () => (
  <SoonPage
    title="Проекты"
    lead="Личные кабинеты на платформе: открываются с покупкой лицензии или подпиской, партнёрам — бесплатно или со скидкой."
    note="Здесь появятся ваши проекты, когда они будут открыты. Пока у вас нет ни одного."
    needsRole
  />
);

export const AssistantPage = () => (
  <SoonPage
    title="AI Ассистент"
    lead="Помощник, который отвечает на вопросы по кабинету и проекту."
    note="Ассистент уже работает в панели справа — откройте её значком в шапке. Отдельная страница с историей переписки появится позже."
  />
);

export default SoonPage;
